import config from 'constants/apiConfig';
import axios from 'axios';
import {
  UPDATE_CURRENT_AOR_REQUEST,
  UPDATE_CURRENT_AOR_SUCCESS,
  UPDATE_CURRENT_AOR_ERROR,
} from 'constants/location-action-types';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function updateCurrentAORRequest() {
  return {
    type: UPDATE_CURRENT_AOR_REQUEST,
  };
}

function updateCurrentAORSuccess(aor) {
  return {
    type: UPDATE_CURRENT_AOR_SUCCESS,
    payload: aor,
  };
}

function updateCurrentAORError(error) {
  const errorMessage =
    'updateCurrentAORError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_CURRENT_AOR_ERROR,
  };
}

export const updateCurrentAOR = (aor) => {
  return (dispatch, getState) => {
    dispatch(updateCurrentAORRequest());
    const { currently_selected } = getState().app.user;
    const new_currently_selected = {
      ...currently_selected,
      aor_id: !!aor && aor.id,
    };
    return axios(config.apiGateway.updateCurrentlySelected, {
      method: 'POST',
      data: JSON.stringify({
        currently_selected: new_currently_selected,
      }),
    })
      .then(() => {
        dispatch(updateCurrentAORSuccess(aor));
      })
      .catch((error) => {
        dispatch(updateCurrentAORError(error));
      });
  };
};
